
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"7iu2usafoa","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h24v24H0z"}})]),_c('g',{attrs:{"mask":"url(#7iu2usafoa)"}},[_c('path',{attrs:{"d":"M16 12l2 2v2h-5v6l-1 1-1-1v-6H6v-2l2-2V5H7V3h10v2h-1v7zm-7.15 2h6.3L14 12.85V5h-4v7.85L8.85 14z","fill":"currentColor"}})])])
          )
        }
      }
    